import { transformNumberCurrency } from '@utils';
import { ItemAmount, ItemContainer, ItemIcon, ItemTitle } from './styles';

export const ItemDashboard = ({ title, amount, style, icon, bgicon }) => {
  return (
    <ItemContainer>
      <ItemIcon bg={bgicon}>{icon}</ItemIcon>

      <div>
        <ItemAmount>{transformNumberCurrency(amount, style)}</ItemAmount>
        <ItemTitle>{title}</ItemTitle>
      </div>
    </ItemContainer>
  );
};
